export const USER_REGISTER = "external/";
export const USER_LOGIN = "external/sign_in";
export const USER_LOGOUT = "external/sign_out";
export const EDIT_PROFILE = "external/";
export const GET_USER = "users/me";
export const DELETE_PROFILE = "users/delete_profile";
export const GET_LOCALE = "users/set_locale";
export const UNLOCK_ACCOUNT = "external/unlock";
export const ACCEPT_UNLOCK_EMAIL = "external/unlock";
export const FORGET_PASSWORD = "external/password";
export const RESET_PASSWORD = "external/password";
export const RESEND_CONFIRMATION_EMAIL = "external/confirmation";
export const HOME_SLIDER = "assets/featured.json";
export const SEARCH_ASSETS = "assets";
export const MAP_ASSETS = "asset_map";
export const PROPERTY_DETAILS_PAGE = "asset_details";
export const INFORMATION_REQUEST = "create_information_request";
export const REQUEST_VIEWING = "create_viewing_request";
export const ADD_OR_REMOVE_WATCHLIST = "create_or_delete_from_watchlist";
export const WATCHLIST = "watchlists_page";
export const DOCUMENTS = "documents";
export const REQUEST_MORTGAGE = "create_financing_request";
export const CREATE_OFFER = "create_offer";
export const UPDATE_OFFER = "update_offer";
export const GET_REGION_PROVINCES = "get_region_provinces";
export const PROPERTY_TYPE_CODES = "property_types";
export const USER_CHATS = "user_chats";
export const USER_CHAT_MESSAGES = "user_chat_messages";
export const USER_CHAT_ATTACHMENTS = "user_chat_attachments";
export const USER_REQUESTS = "user_requests";
export const LOCATIONS = "locations";
export const ADVICE_REQUESTS = "advice_requests";
export const STRIPE_SESSION = "stripe/sessions";
export const USER_INVITATION = "user_invitations";
export const GET_USER_INVITATION = "invitation";
export const ACCEPT_USER_INVITATION = "invitation";
export const RESEND_USER_INVITATION = "user_invitations/resend_invitation";
export const UPDATE_CONSENTS = "users/update_consents";
export const GET_SETTINGS = "settings";
